import { Input } from 'antd';
import styled from 'styled-components';

export const CInput = styled(Input)<{
  width?: string;
  height?: string;
  background?: string;
  fontSize?: string;
  fontWeight?: string;
  styles?: any;
}>`
  width: ${p => p.width || '100%'};
  height: ${p => p.height || '36px'};
  background: ${p => p.background || '#fff'};
  font-size: ${p => p.theme.font.size[p.fontSize || 'xs']};

  .ant-input {
    background: ${p => p.background || '#fff'};
    font-size: ${p => p.theme.font.size[p.fontSize || 'xs']};
    font-weight: ${p => p.theme.font.weight[p.fontWeight || 'regular']};

    &::placeholder {
      font-size: ${p => p.theme.font.size[p.fontSize || 'xs']};
    }
  }
  ${p => p.styles}
`;
